import { useState, useEffect } from 'react';
import SEO from '../../components/SEO';
import Hero from './components/Hero';
import Services from './components/Services';
import BookingInfo from './components/BookingInfo';
import Barbers from './components/Barbers';
import Hours from './components/Hours';
import Location from './components/Location';
import WhyChoose from './components/WhyChoose';
import Reviews from './components/Reviews';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openBooking = () => {
    window.open('https://book.squareup.com/appointments/yc3ukarfxsbty9/location/LHRN4K68W4NE0', '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO />
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img src="https://static.readdy.ai/image/559167c3f2f3505c4b7c1eaccde744d9/54c40221c067c562571a6d30c158173b.jpeg" alt="Reborn Barbershop Logo" className="h-12 w-auto" />
          </div>
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className="text-white text-sm tracking-widest hover:text-red-600 transition-colors whitespace-nowrap">SERVICES</button>
            <button onClick={() => scrollToSection('barbers')} className="text-white text-sm tracking-widest hover:text-red-600 transition-colors whitespace-nowrap">BARBERS</button>
            <button onClick={() => scrollToSection('hours')} className="text-white text-sm tracking-widest hover:text-red-600 transition-colors whitespace-nowrap">HOURS</button>
            <button onClick={() => scrollToSection('location')} className="text-white text-sm tracking-widest hover:text-red-600 transition-colors whitespace-nowrap">LOCATION</button>
            <button onClick={() => scrollToSection('reviews')} className="text-white text-sm tracking-widest hover:text-red-600 transition-colors whitespace-nowrap">REVIEWS</button>
          </div>
          <div className="flex items-center gap-4">
            <a href="tel:0451279664" className="hidden md:flex items-center gap-2 text-white hover:text-red-600 transition-colors whitespace-nowrap">
              <i className="ri-phone-fill"></i>
              <span className="text-sm">0451 279 664</span>
            </a>
            <button onClick={openBooking} className="bg-red-600 text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-red-700 transition-all hover:shadow-lg hover:shadow-red-600/50 whitespace-nowrap cursor-pointer">
              BOOK NOW
            </button>
          </div>
        </div>
      </nav>

      <Hero />
      <Services />
      <BookingInfo />
      <Barbers />
      <Hours />
      <Location />
      <WhyChoose />
      <Reviews />
      <FinalCTA />
      <Footer />
    </div>
  );
}